export const generateFields = (data: Record<string, any>, hasNotAccountingFirm: boolean) => {
  return [
    {
      name: "sellBookCode",
      value:
        !hasNotAccountingFirm && data?.sellBookData
          ? {
              label: `${data?.sellBookData?.code} - ${data?.sellBookData?.name}`,
              value: data?.sellBookData?.code,
            }
          : data?.sellBookCode,
    },
    {
      name: "clientCounterpartAccount",
      value:
        !hasNotAccountingFirm && data?.clientCounterpartData
          ? {
              label: `${data?.clientCounterpartData?.code} - ${data?.clientCounterpartData?.name}`,
              value: data?.clientCounterpartData?.code,
            }
          : data?.clientCounterpartAccount,
    },
    {
      name: "advancePaymentIssuedCounterpart",
      value:
        !hasNotAccountingFirm && data?.advancePaymentIssuedCounterpartData
          ? {
              label: `${data?.advancePaymentIssuedCounterpartData?.code} - ${data?.advancePaymentIssuedCounterpartData?.name}`,
              value: data?.advancePaymentIssuedCounterpartData?.code,
            }
          : data?.advancePaymentIssuedCounterpart,
    },
    {
      name: "advancePaymentReceivedCounterpart",
      value:
        !hasNotAccountingFirm && data?.advancePaymentReceivedCounterpartData
          ? {
              label: `${data?.advancePaymentReceivedCounterpartData?.code} - ${data?.advancePaymentReceivedCounterpartData?.name}`,
              value: data?.advancePaymentReceivedCounterpartData?.code,
            }
          : data?.advancePaymentReceivedCounterpart,
    },
    {
      name: "advancePaymentIssuedTvaCounterpart",
      value:
        !hasNotAccountingFirm && data?.advancePaymentIssuedTvaCounterpartData
          ? {
              label: `${data?.advancePaymentIssuedTvaCounterpartData?.code} - ${data?.advancePaymentIssuedTvaCounterpartData?.name}`,
              value: data?.advancePaymentIssuedTvaCounterpartData?.code,
            }
          : data?.advancePaymentIssuedTvaCounterpart,
    },
    {
      name: "advancePaymentReceivedTvaCounterpart",
      value:
        !hasNotAccountingFirm && data?.advancePaymentReceivedTvaCounterpartData
          ? {
              label: `${data?.advancePaymentReceivedTvaCounterpartData?.code} - ${data?.advancePaymentReceivedTvaCounterpartData?.name}`,
              value: data?.advancePaymentReceivedTvaCounterpartData?.code,
            }
          : data?.advancePaymentReceivedTvaCounterpart,
    },
  ];
};
